import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "flex h-full flex-col gap-5 overflow-y-auto p-4 pt-20 xl:p-8 xl:pt-8" };
const _hoisted_2 = { class: "flex flex-wrap items-start justify-between gap-3" };
const _hoisted_3 = { class: "text-2xl font-semibold text-eblack-900" };
const _hoisted_4 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
    key: 0,
    class: "flex flex-wrap items-center justify-between gap-3 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700",
    "data-test": "tenant-payments-error"
};
const _hoisted_7 = { class: "rounded-lg border border-ewhite-200 bg-white" };
const _hoisted_8 = { class: "grid gap-3 border-b border-ewhite-100 p-4 md:grid-cols-[minmax(180px,1fr)_180px_auto]" };
const _hoisted_9 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_10 = ["placeholder"];
const _hoisted_11 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_12 = { value: "" };
const _hoisted_13 = ["value"];
const _hoisted_14 = { class: "flex items-end gap-2" };
const _hoisted_15 = { class: "overflow-x-auto" };
const _hoisted_16 = { class: "min-w-[840px] w-full divide-y divide-ewhite-100 text-left text-sm" };
const _hoisted_17 = { class: "bg-ewhite-50 text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_18 = { class: "px-4 py-3" };
const _hoisted_19 = { class: "px-4 py-3" };
const _hoisted_20 = { class: "px-4 py-3" };
const _hoisted_21 = { class: "px-4 py-3" };
const _hoisted_22 = { class: "px-4 py-3" };
const _hoisted_23 = { class: "divide-y divide-ewhite-100 bg-white" };
const _hoisted_24 = { key: 0 };
const _hoisted_25 = {
    colspan: "5",
    class: "px-4 py-8 text-center text-eblack-500"
};
const _hoisted_26 = { key: 1 };
const _hoisted_27 = {
    colspan: "5",
    class: "px-4 py-8 text-center text-eblack-500"
};
const _hoisted_28 = { class: "px-4 py-3 align-top" };
const _hoisted_29 = { class: "font-semibold text-eblack-900" };
const _hoisted_30 = { class: "text-xs text-eblack-500" };
const _hoisted_31 = { class: "px-4 py-3 align-top text-eblack-700" };
const _hoisted_32 = { class: "px-4 py-3 align-top" };
const _hoisted_33 = { class: "px-4 py-3 align-top font-medium text-eblack-900" };
const _hoisted_34 = { class: "px-4 py-3 align-top text-eblack-600" };
import { computed, onMounted, reactive } from "vue";
import { useI18n } from "vue-i18n";
import { IconRefresh } from "@tabler/icons-vue";
import { useAuthStore } from "@/domains/auth";
import { usePaymentOperationsStore } from "@/domains/payments";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaymentsIndex',
    setup(__props) {
        const { t } = useI18n();
        const authStore = useAuthStore();
        const store = usePaymentOperationsStore();
        const filters = reactive({
            search: "",
            status: "",
        });
        const isProvider = computed(() => authStore.currentOrgType === "provider");
        const currentList = computed(() => isProvider.value ? store.tenantProviderPayables : store.tenantCollections);
        const currentRows = computed(() => currentList.value.items);
        const statusOptions = computed(() => isProvider.value
            ? ["held", "ready", "payout_pending", "released", "void"]
            : [
                "checkout_created",
                "processing",
                "succeeded",
                "failed",
                "cancelled",
                "expired",
            ]);
        const pageTitle = computed(() => isProvider.value
            ? t("settings.billing.payments.tenant.provider_title")
            : t("settings.billing.payments.tenant.concierge_title"));
        const pageDescription = computed(() => isProvider.value
            ? t("settings.billing.payments.tenant.provider_description")
            : t("settings.billing.payments.tenant.concierge_description"));
        const contextHeader = computed(() => isProvider.value
            ? t("settings.billing.payments.table.concierge")
            : t("settings.billing.payments.table.itinerary"));
        onMounted(load);
        async function load() {
            const query = {
                search: filters.search || undefined,
                status: filters.status || undefined,
            };
            if (isProvider.value) {
                await store.fetchTenantProviderPayables(query);
                return;
            }
            await store.fetchTenantCollections(query);
        }
        function clearFilters() {
            filters.search = "";
            filters.status = "";
            load();
        }
        function rowMeta(row) {
            if (isProvider.value) {
                return `${t("settings.billing.payments.table.booking")} #${row.booking_id ?? "-"}`;
            }
            return `${t("settings.billing.payments.table.itinerary")} #${row.itinerary_id}`;
        }
        function contextLabel(row) {
            if (isProvider.value)
                return row.concierge?.display_name ?? "-";
            return `#${row.itinerary_id}`;
        }
        function money(amountMinor, currency) {
            return new Intl.NumberFormat(undefined, {
                style: "currency",
                currency: currency || "USD",
            }).format((amountMinor || 0) / 100);
        }
        function dateLabel(value) {
            if (!value)
                return "-";
            return new Intl.DateTimeFormat(undefined, {
                dateStyle: "medium",
                timeStyle: "short",
            }).format(new Date(value));
        }
        function statusLabel(status) {
            return t(`settings.billing.payments.status.${status}`, status);
        }
        function statusClass(status) {
            if (["succeeded", "paid", "released"].includes(status)) {
                return "bg-green-50 text-green-700";
            }
            if (["failed", "cancelled", "expired", "void"].includes(status)) {
                return "bg-red-50 text-red-700";
            }
            if (["processing", "payout_pending", "ready"].includes(status)) {
                return "bg-blue-50 text-blue-700";
            }
            return "bg-ewhite-100 text-eblack-700";
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("section", _hoisted_2, [
                    _createElementVNode("div", null, [
                        _createElementVNode("h1", _hoisted_3, _toDisplayString(pageTitle.value), 1),
                        _createElementVNode("p", _hoisted_4, _toDisplayString(pageDescription.value), 1)
                    ]),
                    _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex h-9 items-center gap-2 rounded-lg border border-ewhite-200 bg-white px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                        disabled: _unref(store).isLoading,
                        "data-test": "tenant-payments-refresh",
                        onClick: load
                    }, [
                        _createVNode(_unref(IconRefresh), { class: "h-4 w-4" }),
                        _createTextVNode(" " + _toDisplayString(_unref(t)("settings.billing.actions.refresh")), 1)
                    ], 8, _hoisted_5)
                ]),
                (_unref(store).error)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
                        _createElementVNode("span", null, _toDisplayString(_unref(store).error), 1),
                        _createElementVNode("button", {
                            type: "button",
                            class: "rounded-md border border-red-200 px-2.5 py-1 font-medium hover:bg-red-100",
                            onClick: load
                        }, _toDisplayString(_unref(t)("settings.billing.actions.retry")), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("section", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("label", _hoisted_9, [
                            _createTextVNode(_toDisplayString(_unref(t)("settings.billing.payments.filters.search")) + " ", 1),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((filters.search) = $event)),
                                class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                "data-test": "tenant-payments-search",
                                placeholder: _unref(t)('settings.billing.payments.filters.search_placeholder'),
                                onKeydown: _withKeys(load, ["enter"])
                            }, null, 40, _hoisted_10), [
                                [
                                    _vModelText,
                                    filters.search,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_11, [
                            _createTextVNode(_toDisplayString(_unref(t)("settings.billing.payments.filters.status")) + " ", 1),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((filters.status) = $event)),
                                class: "h-9 rounded-md border border-ewhite-200 px-2 text-sm",
                                "data-test": "tenant-payments-status-filter",
                                onChange: load
                            }, [
                                _createElementVNode("option", _hoisted_12, _toDisplayString(_unref(t)("settings.billing.payments.filters.any_status")), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusOptions.value, (status) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: status,
                                        value: status
                                    }, _toDisplayString(statusLabel(status)), 9, _hoisted_13));
                                }), 128))
                            ], 544), [
                                [_vModelSelect, filters.status]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "h-9 rounded-lg border border-ewhite-200 px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50",
                                "data-test": "tenant-payments-apply",
                                onClick: load
                            }, _toDisplayString(_unref(t)("settings.billing.actions.apply")), 1),
                            _createElementVNode("button", {
                                type: "button",
                                class: "h-9 rounded-lg px-3 text-sm font-medium text-eblack-500 hover:bg-ewhite-50",
                                "data-test": "tenant-payments-clear",
                                onClick: clearFilters
                            }, _toDisplayString(_unref(t)("settings.billing.actions.clear")), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("table", _hoisted_16, [
                            _createElementVNode("thead", _hoisted_17, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_18, _toDisplayString(_unref(t)("settings.billing.payments.table.record")), 1),
                                    _createElementVNode("th", _hoisted_19, _toDisplayString(contextHeader.value), 1),
                                    _createElementVNode("th", _hoisted_20, _toDisplayString(_unref(t)("settings.billing.payments.table.status")), 1),
                                    _createElementVNode("th", _hoisted_21, _toDisplayString(_unref(t)("settings.billing.payments.table.amount")), 1),
                                    _createElementVNode("th", _hoisted_22, _toDisplayString(_unref(t)("settings.billing.payments.table.updated")), 1)
                                ])
                            ]),
                            _createElementVNode("tbody", _hoisted_23, [
                                (_unref(store).isLoading)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                                        _createElementVNode("td", _hoisted_25, _toDisplayString(_unref(t)("settings.billing.payments.loading")), 1)
                                    ]))
                                    : (currentRows.value.length === 0)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                                            _createElementVNode("td", _hoisted_27, _toDisplayString(_unref(t)("settings.billing.payments.empty")), 1)
                                        ]))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(currentRows.value, (row) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: row.id
                                            }, [
                                                _createElementVNode("td", _hoisted_28, [
                                                    _createElementVNode("p", _hoisted_29, "#" + _toDisplayString(row.id), 1),
                                                    _createElementVNode("p", _hoisted_30, _toDisplayString(rowMeta(row)), 1)
                                                ]),
                                                _createElementVNode("td", _hoisted_31, _toDisplayString(contextLabel(row)), 1),
                                                _createElementVNode("td", _hoisted_32, [
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(["inline-flex rounded-full px-2 py-0.5 text-xs font-semibold", statusClass(row.status)])
                                                    }, _toDisplayString(statusLabel(row.status)), 3)
                                                ]),
                                                _createElementVNode("td", _hoisted_33, _toDisplayString(money(row.amount_minor, row.currency)), 1),
                                                _createElementVNode("td", _hoisted_34, _toDisplayString(dateLabel(row.updated_at || row.timeline?.updated_at)), 1)
                                            ]));
                                        }), 128))
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
